export default {
  invoice_id: null,
  item_id: null,
  category_id: null,
  subcategory_id: null,
  name: '',
  title: '',
  description: null,
  quantity: 1,
  price: 0,
  enpav: null,
  discount_type: 'fixed',
  discount_val: 0,
  discount: 0,
  total: 0,
  totalTax: 0,
  totalSimpleTax: 0,
  totalCompoundTax: 0,
  tax: 0,
  taxes: [],
  fctax: 0,
  indtax: 0,
  tax_motivation: null,
}
